import moment from 'moment';

export function useOtherProps(otherProps, type) {
    // A curated list of field specific props, extracted from the main props.
    // This ensures we don't pass any ill-advised props down to the DOM.
    // If anything you need is missing, add it here, along with
    // any sensible defaults
    const fieldPropsRaw = {
        className: otherProps?.className,
        disabled: otherProps?.disabled,
        format: otherProps?.format,
        options: otherProps?.options || otherProps?.choices || [],
        picker: otherProps?.picker,
        placeholder: otherProps?.placeholder,
        required: otherProps?.required,
        rows: otherProps?.rows,
        size: otherProps?.size || 'large',
        inputMode: otherProps?.inputMode,
        style: otherProps?.style
    };

    // Don't allow disabled options if there are no options to begin with
    if (['select', 'radio', 'multicheck'].includes(type)) {
        fieldPropsRaw.optionsDisabled = otherProps?.optionsDisabled || [];
    }

    if (type === 'text') {
        fieldPropsRaw.maxLength = otherProps?.maxLength;
    }

    if (type === 'textArea') {
        fieldPropsRaw.autoSize = otherProps?.autoSize;
    }

    // allow extra text content props &c for passwords
    if (type === 'password') {
        // undefined is fine because the component has defaults within
        fieldPropsRaw.descriptions = otherProps?.descriptions;
        fieldPropsRaw.hide = otherProps?.hide;
        fieldPropsRaw.show = otherProps?.show;
        fieldPropsRaw.useStrengthMeter = otherProps?.useStrengthMeter;
        fieldPropsRaw.zxcvbnErrorText = otherProps?.zxcvbnErrorText;
    }

    if (type === 'typeahead') {
        fieldPropsRaw.defaultOpen = otherProps.defaultOpen;
    }

    // AntD DatePicker and RangePicker in v4.20.3 expects a MomentJS object, so we transform it here.
    // If and when we upgrade AntD, we can switch this to DayJS, which is what the newer versions expect.
    // Any other Date props that we want to pass to DatePicker or RangePicker from FormControl will also
    // need to be converted to a moment object
    if (type === 'date') {
        fieldPropsRaw.defaultValue = otherProps?.defaultValue
            ? moment(otherProps?.defaultValue, 'YYYY-MM-DD')
            : undefined;
        fieldPropsRaw.disabledDate = otherProps?.disabledDate;
    }

    if (type === 'dateRange') {
        fieldPropsRaw.defaultValue =
            otherProps?.defaultValue?.length > 0
                ? [
                      moment(otherProps?.defaultValue[0], 'YYYY-MM-DD'),
                      moment(otherProps?.defaultValue[1], 'YYYY-MM-DD')
                  ]
                : undefined;
    }

    if (type === 'timeSlotPicker') {
        fieldPropsRaw.size = otherProps?.size || 'medium';
        fieldPropsRaw.timeSlotBreakpoints = otherProps?.timeSlotBreakpoints;
        fieldPropsRaw.timezone = otherProps?.timezone;
    }

    return fieldPropsRaw;
}
